// endRoom / reopenRoom — toggle meet_rooms.ended_at. The meet_rooms_update
// RLS policy allows the room creator (and admins) to update. Other members
// get a silent failure, which is what we want — only owners can close a
// room.
//
// Ending a room doesn't disconnect live participants — it's an advisory
// state flag. Components read it to sort, badge, and hide the call button
// on the room row. If you want to forcibly kick everyone, that's a future
// `RoomServiceClient.deleteRoom` call from a new Edge Function.
//
// migrated 2026-04-27 to SDK route workspaceProject.meet.rooms (end / reopen)
import { getSDK } from '@symbo-ls/workspace-shared/functions/sdk.js'

export const endRoom = async function (roomId) {
  const root = this.state.root
  const id = roomId || root.activeRoomId
  if (!id) return false
  const endedAt = new Date().toISOString()
  try {
    await getSDK().execute('workspaceProject.meet.rooms', 'end', { id })
  } catch (err) {
    console.error('[endRoom]', err?.message || err)
    return false
  }
  // Optimistic state merge
  const rooms = (root.rooms || []).map(r => r.id === id ? { ...r, endedAt } : r)
  root.update({ rooms })
  return true
}

export const reopenRoom = async function (roomId) {
  const root = this.state.root
  const id = roomId || root.activeRoomId
  if (!id) return false
  try {
    await getSDK().execute('workspaceProject.meet.rooms', 'reopen', { id })
  } catch (err) {
    console.error('[reopenRoom]', err?.message || err)
    return false
  }
  const rooms = (root.rooms || []).map(r => r.id === id ? { ...r, endedAt: null, livekitInitialized: false } : r)
  root.update({ rooms })
  return true
}
